module.exports = __webpack_public_path__ + "static/media/item-add.44db02a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/item-add.svg
// module id = 657
// module chunks = 0